import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { SettingsEffects } from './settings.effects'
import * as fromsettings from './settings.reducer'

@NgModule({
  declarations: [],
  exports: [],
  imports: [
    StoreModule.forFeature(
      fromsettings.FEATURE_NAME,
      fromsettings.settingsReducer
    ),
    EffectsModule.forFeature([SettingsEffects])
  ],
  providers: []
})
export class SettingsModule {}
